import { render, staticRenderFns } from "./SimsColumn.vue?vue&type=template&id=60e5be7c"
import script from "./SimsColumn.vue?vue&type=script&lang=js"
export * from "./SimsColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports